/** Identity returned by this exact successful OSS PostObject, not a guessed MD5. */
export function uploadedImageIdentity(uploadedPath, responseBody) {
  if (typeof uploadedPath !== 'string' || !/^static\/[\w.-]+\.(?:png|jpe?g|webp)$/i.test(uploadedPath)
    || typeof responseBody !== 'string' || /<!/.test(responseBody)) return null;
  const body = responseBody.trim().replace(/^<\?xml[^?]*\?>\s*/, '').replaceAll('&quot;', '"');
  if (body.includes('&')) return null;
  if (!/^<PostResponse>[\s\S]*<\/PostResponse>$/.test(body)) return null;
  const keys = [...body.matchAll(/<Key>([^<]*)<\/Key>/g)];
  const etags = [...body.matchAll(/<ETag>(?:"([a-fA-F0-9]{32})"|([a-fA-F0-9]{32}))<\/ETag>/g)];
  if (keys.length !== 1 || keys[0][1] !== uploadedPath || etags.length !== 1) return null;
  const extension = uploadedPath.slice(uploadedPath.lastIndexOf('.'));
  return { uploadedPath, canonicalPath: `static/${(etags[0][1] || etags[0][2]).toLowerCase()}${extension}` };
}
